import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-fullscreen w-100" }
const _hoisted_3 = { class: "modal-content bg-dark text-light" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = ["data-bs-target"]
const _hoisted_6 = {
  key: 1,
  type: "button",
  class: "btn-close btn-close-white",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "modal-body h-100 overflow-hidden" }
const _hoisted_8 = { class: "h-100 w-100 d-flex" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "img-nav-buttons" }
const _hoisted_11 = { class: "img-nav-button ps-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, null, -1)
const _hoisted_13 = { class: "img-nav-button pe-4" }
const _hoisted_14 = {
  key: 0,
  class: "img-indicator-wrapper"
}
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: _ctx.id,
    tabindex: "-1",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.parentModal)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn-close btn-close-white",
                "data-bs-toggle": "modal",
                "data-bs-target": '#' + _ctx.parentModal,
                "data-bs-dismiss": "modal"
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("button", _hoisted_6))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              class: "m-auto max-img",
              src: _ctx.imgs[_ctx.currImg]
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("i", {
                class: "bi bi-chevron-left",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.lastImg && _ctx.lastImg(...args)))
              })
            ]),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("i", {
                class: "bi bi-chevron-right",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextImg && _ctx.nextImg(...args)))
              })
            ])
          ]),
          (_ctx.manual)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imgs, (img, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["img-indicator", {active: index === _ctx.currImg}]),
                    key: img,
                    onClick: ($event: any) => (_ctx.setImg(index))
                  }, null, 10, _hoisted_15))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}